import ItemHandler from './ItemHandler';

import './ItemHandler.scss';

export default ItemHandler;
